import { LogoContainer } from 'reservations/payments/components/LogoContainer';

export function MasterCardLogo() {
  return (
    <LogoContainer>
      <svg
        data-testid="mastercard-logo"
        width="33"
        height="20"
        viewBox="0 0 33 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.7028 18.2848H31.6775V18.7848C31.6775 19.0909 31.4204 19.3481 31.1142 19.3481H1.49396C1.18782 19.3481 0.930664 19.0909 0.930664 18.7848V1.06329C0.930664 0.757155 1.18782 0.5 1.49396 0.5H31.1395C31.4457 0.5 31.7028 0.757154 31.7028 1.06329V18.2848Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M18.9319 5.49506H14.0654V14.2517H18.9319V5.49506Z"
          fill="#FF5F00"
        />
        <path
          d="M14.3748 9.87339C14.3748 8.09421 15.2091 6.51615 16.4913 5.49505C15.5489 4.75244 14.3594 4.30377 13.0616 4.30377C9.98729 4.30377 7.5 6.79463 7.5 9.87339C7.5 12.9522 9.98729 15.443 13.0616 15.443C14.3594 15.443 15.5489 14.9943 16.4913 14.2517C15.2091 13.2306 14.3748 11.6526 14.3748 9.87339Z"
          fill="#EB001B"
        />
        <path
          d="M25.4982 9.87339C25.4982 12.9522 23.0109 15.443 19.9365 15.443C18.6388 15.443 17.4492 14.9943 16.5068 14.2517C17.8046 13.2306 18.6234 11.6526 18.6234 9.87339C18.6234 8.09421 17.7891 6.51615 16.5068 5.49505C17.4492 4.75244 18.6388 4.30377 19.9365 4.30377C23.0109 4.30377 25.4982 6.79463 25.4982 9.87339Z"
          fill="#F79E1B"
        />
        <path
          d="M24.9724 13.3235V13.1378H25.0496V13.1069H24.8643V13.1378H24.9415V13.3235H24.9724ZM25.3277 13.3235V13.1069H25.2659L25.2041 13.2616L25.1423 13.1069H25.0805V13.3235H25.1269V13.1533L25.1887 13.2925H25.235L25.2968 13.1533V13.3235H25.3277Z"
          fill="#F79E1B"
        />
      </svg>
    </LogoContainer>
  );
}
